module.exports = __webpack_public_path__ + "img/157.a17a3edf.jpg";